import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, StateKey } from './global-store.state';

export const selectGlobalState = createFeatureSelector<State>(StateKey);

export const selectGlobalSic = createSelector(
  selectGlobalState,
  (state: State) => state.sic
);
